import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "io-mfe-ig-procedure-header" }

import ProcedureTableToolbar from 'components/search/procedure/ProcedureTableToolbar.vue';
import ProcedureHeaderProperty from 'components/search/procedure/ProcedureHeaderProperty.vue';
import { useSearchStore } from 'stores/search-store';
import { useHistoryStore } from 'stores/history-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcedureTableHeader',
  setup(__props) {

const searchStore = useSearchStore();
const history = useHistoryStore<string>('procedure-history');

const onBackButtonClicked = () => {
  searchStore.setSelectedProcedureCode(history.getPrev() || '', false);
};

const onNextButtonClicked = () => {
  searchStore.setSelectedProcedureCode(history.getNext() || '', false);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProcedureTableToolbar, {
      "enable-back-button": _unref(history).isPrevAvailable,
      "enable-next-button": _unref(history).isNextAvailable,
      onBackButtonClicked: _cache[0] || (_cache[0] = ($event: any) => (onBackButtonClicked())),
      onNextButtonClicked: _cache[1] || (_cache[1] = ($event: any) => (onNextButtonClicked()))
    }, null, 8, ["enable-back-button", "enable-next-button"]),
    _createVNode(ProcedureHeaderProperty, {
      label: "Section",
      item: _unref(searchStore).getSelectedProcedureParts[0]
    }, null, 8, ["item"]),
    _createVNode(ProcedureHeaderProperty, {
      label: "Body System",
      item: _unref(searchStore).getSelectedProcedureParts[1]
    }, {
      default: _withCtx(() => [
        _createTextVNode(">")
      ]),
      _: 1
    }, 8, ["item"]),
    _createVNode(ProcedureHeaderProperty, {
      label: "Operation",
      item: _unref(searchStore).getSelectedProcedureParts[2]
    }, {
      default: _withCtx(() => [
        _createTextVNode(">")
      ]),
      _: 1
    }, 8, ["item"])
  ]))
}
}

})